import axios from 'axios';

/**
 * 设置店铺提成方案列表
 * 
 * @param {*} params
 */
export function getStaffAttrList() {
  return axios.post('/data/get_commission_attr');
}

export function getAdminList() {
  return axios.post('/user/admin_to_get_all_list');
}
